import { MrbBaseRouteStore } from "mrb/core";
import { AppHomeSectionService, GenreLookupService, PodcastCategoryLookupService } from "common/services";

class BaseHomeSectionListRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(AppHomeSectionService);
        this.genreLookupService = this.rootStore.createApplicationService(GenreLookupService);
        this.podcastCategoryLookupService = this.rootStore.createApplicationService(PodcastCategoryLookupService);
    }

    async getAll(systemType) {
        const response = await this.service.getAll({
            embed: "items,items.album,items.artist,items.station,items.podcast",
            systemType: systemType,
        });
        return response.data;
    }

    async update(systemType, resources) {
        const response = await this.service.update(systemType, resources);
        return response.data;
    }

    async getContent(filter) {
        const response = await this.service.getContent(filter);
        return response.data;
    }

    async findGenres(searchPhrase) {
        const response = await this.genreLookupService.find(searchPhrase);
        return response.data;
    }

    async findPodcastCategories(searchPhrase) {
        const response = await this.podcastCategoryLookupService.find(searchPhrase);
        return response.data;
    }
}

export default BaseHomeSectionListRouteStore;
